import React from "react";
import styled, { css } from "styled-components";
import { Colors } from "../../../theme/colors";
import { FontSizes } from "../../../theme/fonts";

interface InputProps {
  className?: string;
  hasError?: boolean;
  placeholder?: string;
  value: string;
  onChangeValue: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: React.FocusEventHandler;
}

const Input = ({
  className,
  hasError = false,
  placeholder,
  value,
  onChangeValue,
  onBlur,
}: InputProps) => (
  <InputWrapper className={className} hasError={hasError}>
    <InputStyled
      placeholder={placeholder}
      value={value}
      onChange={onChangeValue}
      onBlur={onBlur}
    />
  </InputWrapper>
);

const InputWrapper = styled.div<{ hasError: boolean }>`
  display: flex;
  flex-wrap: nowrap;
  background-color: ${Colors.White};
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;

  ${(props) => {
    let styles = css``;
    if (props.hasError)
      styles = css`
        border: 1px solid ${Colors.Error};
      `;
    else
      styles = css`
        border: 1px solid ${Colors.Border};
      `;
    return styles;
  }}
`;

const InputStyled = styled.input`
  flex: 1;
  outline: 0;
  border-width: 0;
  padding: ${4 * 3}px;
  box-sizing: border-box;
  min-width: 0;
  font-size: ${FontSizes.Paragraph};
`;

export default Input;
